(function(){
  if (window.kgSibSizeInit) return; window.kgSibSizeInit = true;
  var kgLast = '__init__';
  var kgTicks = 0;
  var kgTimer = null;
  var kgTapped = null;
  var kgSizeRe = /^\s*\d+\s*-?\s*\d*\s*[MY]\s*$/i;
  function kgHolders(){ return document.querySelectorAll('[data-kg-siblings]'); }
  function kgVmap(){
    var hs = kgHolders();
    for (var i = 0; i < hs.length; i++) {
      try {
        var el = hs[i].querySelector('[data-kg-vmap]');
        if (el) return JSON.parse(el.textContent);
      } catch(e){}
    }
    return null;
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    for (var hop = 0; hop < 4 && t && t.nodeType === 1; hop++) {
      var txt = (t.textContent || '').trim();
      if (txt.length <= 8 && kgSizeRe.test(txt)) { kgTapped = txt; return; }
      t = t.parentElement;
    }
  }, true);
  function kgSel(){
    if (!kgHolders().length) return {sel: null, src: 'nohold'};
    if (kgTapped) return {sel: kgTapped, src: 'tap'};
    var scope = document.querySelector('.product__page') || document;
    var radios = scope.querySelectorAll('input[type="radio"]:checked');
    for (var j = 0; j < radios.length; j++) {
      var v = (radios[j].value || '').trim();
      if (kgSizeRe.test(v)) return {sel: v, src: 'radio'};
    }
    var map = kgVmap();
    if (map) {
      var idEls = document.querySelectorAll('[name="id"]');
      for (var k = 0; k < idEls.length; k++) {
        var vid = (idEls[k].value || '').trim();
        if (vid && map[vid]) return {sel: map[vid], src: 'form'};
      }
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m && map[m[1]]) return {sel: map[m[1]], src: 'url'};
    }
    var h0 = kgHolders()[0];
    return {sel: (h0 && h0.getAttribute('data-kg-default')) || null, src: 'def'};
  }
  function kgApply(sel){
    kgHolders().forEach(function(holder){
      holder.querySelectorAll('.kg-pdp-sib__dot').forEach(function(d){
        var base = d.getAttribute('data-kg-base') || d.getAttribute('href');
        if (!sel) { d.classList.remove('kg-nosize'); d.setAttribute('href', base); return; }
        var sizes = (d.getAttribute('data-kg-sizes') || '').split('|');
        var ok = sizes.some(function(s){ return s.trim().toLowerCase() === sel.toLowerCase(); });
        d.classList.toggle('kg-nosize', !ok);
        var href = base;
        var pairs = (d.getAttribute('data-kg-vids') || '').split('|');
        for (var i = 0; i < pairs.length; i++) {
          var kv = pairs[i].split(':');
          if (kv.length === 2 && kv[0].trim().toLowerCase() === sel.toLowerCase()) {
            href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + kv[1].trim();
            break;
          }
        }
        d.setAttribute('href', href);
      });
    });
  }
  var kgAvail = null;
  function kgMarkSizes(){
    if (!kgHolders().length) return;
    if (!kgAvail) {
      var hs = kgHolders();
      for (var i = 0; i < hs.length && !kgAvail; i++) {
        try {
          var el = hs[i].querySelector('[data-kg-avail]');
          if (el) kgAvail = JSON.parse(el.textContent).map(function(s){ return s.trim().toLowerCase(); });
        } catch(e){}
      }
      if (!kgAvail) return;
    }
    document.querySelectorAll('input[type="radio"]').forEach(function(r){
      var v = (r.value || '').trim();
      if (!kgSizeRe.test(v)) return;
      var lbl = null;
      if (r.id) { try { lbl = document.querySelector('label[for="' + r.id.replace(/"/g, '') + '"]'); } catch(e){} }
      if (!lbl) lbl = r.closest('label');
      if (!lbl) return;
      var out = kgAvail.indexOf(v.toLowerCase()) === -1;
      lbl.classList.toggle('kg-size-strike', out);
    });
  }
  function kgTick(){
    kgTicks++;
    var r = kgSel();
    document.querySelectorAll('[id="kg-debug"]').forEach(function(dbg){
      dbg.textContent = '[' + (r.sel || 'none') + ' | ' + r.src + ' | ' + kgTicks + ' | h' + kgHolders().length + ']';
    });
    if (r.sel !== kgLast) { kgLast = r.sel; kgApply(r.sel); }
    kgMarkSizes();
  }
  function kgStart(){
    if (kgTimer) clearInterval(kgTimer);
    kgLast = '__init__';
    kgAvail = null;
    kgTapped = null;
    kgTimer = setInterval(kgTick, 250);
    kgTick();
  }
  kgStart();
  window.addEventListener('pageshow', function(){ kgStart(); });
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) kgStart(); });
  var kgPrefetched = {};
  function kgPrefetch(e){
    var a = e.target && e.target.closest ? e.target.closest('[data-kg-prefetch]') : null;
    if (!a || !a.href || kgPrefetched[a.href]) return;
    kgPrefetched[a.href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = a.href;
    document.head.appendChild(l);
  }
  document.addEventListener('touchstart', kgPrefetch, {passive: true});
  document.addEventListener('mouseover', kgPrefetch, {passive: true});
})();